<template>
  <div v-if="$store.state.menu.GroupDealer">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Группы" text="Список всех групп">
            <v-btn color="success" @click="openNews" text>Добавить</v-btn>

            <v-data-table :headers="headers" :items="groupList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td
                  :class="`text-xs-left ${(item.is_active) ? 'active' : 'no-active'}`"
                >{{ item.title }}</td>
                <td class="text-xs-left">{{ item.percent }} %</td>
                <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
                <td class="text-xs-right min-width100">
                  <template>
                    <v-icon class="mr-3" @click="openNews(item)">mdi-pencil</v-icon>
                  </template>
                </td>
              </template>
            </v-data-table>

            <v-pagination v-if="last_page>1" v-model="page" class="my-4" :length="last_page"></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
      <Dealer />
    </v-container>
    <div class="small-dialog">
      <v-dialog width="600" v-model="dialog">
        <v-card>
          <v-card-text>
            <v-text-field
              label="Заголовок"
              placeholder="Введите заголовок"
              v-model="title"
              outlined
            ></v-text-field>
            <v-text-field
              label="Процент надбавки"
              placeholder="Введите процент"
              v-model="percent"
              outlined
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="text-xs-center">
            <v-btn color="success" text @click="setGroup">Сохранить</v-btn>
            <v-btn color="primary" text @click="closeNews">Отмена</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";

export default {
  data: () => ({
    loading: true,
    dialog: false,
    search: "",
    page: 1,
    last_page: 0,
    id: null,
    title: "",
    percent: "",
    headers: [
      {
        sortable: false,
        text: "Заголовок",
        value: "phone_number",
      },
      {
        sortable: false,
        text: "Процент надбавки (%)",
        value: "rate",
      },
      {
        sortable: false,
        text: "Дата создания",
        value: "title",
      },

      {
        sortable: false,
        text: "",
        value: "edit",
        align: "right",
      },
    ],
    groupList: [],
  }),
  methods: {
    getNews() {
      axios
        .get("admin/group/list", {
          params: {
            page: this.page,
          },
        })
        .then((response) => {
          this.groupList = response.data.data;
          this.last_page = response.data.last_page;
          this.loading = false;
        })
        .catch((error) => {});
    },
    setGroup() {
      this.loading = true;

      if (this.id) {
        axios
          .put("admin/group/update", {
            id: this.id,
            title: this.title,
            percent: this.percent,
          })
          .then((response) => {
            this.$toast.success({
              title: "Группа",
              message: "Вы добавили новую группу",
            });
            this.closeNews();
          })
          .catch((error) => {
            let data = error.response.data;
            if (data.errors) {
              Object.keys(data.errors).forEach((item) => {
                let err = data.errors[item];
                for (let i = 0; i < err.length; i++) {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        axios
          .post("admin/group/create", {
            title: this.title,
            percent: this.percent,
          })
          .then((response) => {
            this.$toast.success({
              title: "Группа",
              message: "Вы добавили новую группу",
            });
            this.closeNews();
          })
          .catch((error) => {
            let data = error.response.data;
            if (data.errors) {
              Object.keys(data.errors).forEach((item) => {
                let err = data.errors[item];
                for (let i = 0; i < err.length; i++) {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    openNews(item = null) {
      this.dialog = true;
      if (item) {
        this.id = item.id;
        this.title = item.title;
        this.percent = item.percent;
      }
    },
    closeNews() {
      this.loading = true;
      this.getNews();
      this.id = null;
      this.title = "";
      this.percent = "";
      this.dialog = false;
    },
  },
  components: { Loader },
  mounted() {
    this.getNews();
  },
  watch: {
    page() {
      setTimeout(() => {
        this.getNews();
      }, 300);
    },
  },
};
</script>

<style>
.active {
  opacity: 1;
}

.no-active {
  opacity: 0.6;
}
</style>
